import { carouselItems } from '@/mocks/homeData';
import ImageBox from '@/components/base/ImageBox';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            精选深度专题内容，全方位解读娱乐热点事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.slice(0, 3).map((item, i) => (
            <article
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <ImageBox
                src={item.image}
                alt={item.title}
                title={`吃瓜网51焦点专题 - ${item.title}`}
                className="relative w-full aspect-[16/10] overflow-hidden bg-background-100"
                imgClassName="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              >
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[11px] font-semibold rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </ImageBox>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {carouselItems.slice(3).map((item, i) => (
            <article
              key={i + 3}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group cursor-pointer flex flex-col sm:flex-row"
            >
              <ImageBox
                src={item.image}
                alt={item.title}
                title={`吃瓜网51焦点专题 - ${item.title}`}
                className="relative w-full sm:w-48 flex-shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100"
                imgClassName="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              >
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-[11px] font-semibold rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </ImageBox>
              <div className="p-5 flex flex-col justify-center">
                <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}